import type { FC } from 'react';
import { Flex, Shimmer } from '@/_components';
import styles from './ActivitiesLoading.module.css';

export const ActivitiesLoading: FC = () => {
  return (
    <Flex isColumn={true} className={styles.activitiesLoading}>
      <Shimmer
        className={styles.activitiesLoading__Icon}
        width={32}
        isRound={true}
        height={32}
      />
      <Flex isColumn={true} gap={2}>
        <Shimmer width={120} height={16} />
        <Flex gap={4}>
          <Shimmer width={240} height={20} />
          <Shimmer width={80} height={20} />
        </Flex>
      </Flex>
    </Flex>
  );
};
